export default theme => ({
  datagrid_item: {
    paddingRight: 0,
    paddingLeft: 0,
    wordWrap: "break-word",
    width: "100%",
    whiteSpace: "pre-wrap",
  },
  datagrid_item__centered: {
    display: "flex",
    justifyContent: "center",
  },
});
